<template>
  <div>
    <v-card flat>
      <v-card-text>
        <div class="user-detail-grid">
          <div class="user-detail-item">
            <div class="user-detail-label">Full Name</div>
            <div class="user-detail-value">
              {{
                (values.firstName ? values.firstName : null) +
                " " +
                (values.middleName ? values.middleName : null + " ") +
                (values.lastName ? values.lastName : null)
              }}
            </div>
          </div>
          <div class="user-detail-item">
            <div class="user-detail-label">User Name</div>
            <div class="user-detail-value">
              {{ values.username ? values.username : "-" }}
            </div>
          </div>
          <div class="user-detail-item">
            <div class="user-detail-label">Email</div>
            <div class="user-detail-value">
              {{ values.email ? values.email : "-" }}
            </div>
          </div>
          <div class="user-detail-item">
            <div class="user-detail-label">Phone Number</div>
            <div class="user-detail-value">
              {{ values.phoneNumber ? values.phoneNumber : "-" }}
            </div>
          </div>
          <div class="user-detail-item">
            <div class="user-detail-label">Expert Levels</div>
            <div class="user-detail-value">
              {{ values.expertLevels ? values.expertLevels.name : "-" }}
            </div>
          </div>
          <div class="user-detail-item">
            <div class="user-detail-label">Region</div>
            <div class="user-detail-value">
              {{ values.region ? values.region.name : "-" }}
            </div>
          </div>
          <div class="user-detail-item">
            <div class="user-detail-label">Facility Type</div>
            <div class="user-detail-value">
              {{ values.facilityType ? values.facilityType.name : "-" }}
            </div>
          </div>
          <div class="user-detail-item">
            <div class="user-detail-label">Facility</div>
            <div class="user-detail-value">
              {{
                values.userFacility ? values.userFacility.name : (values.educationalInstitution ?
                    values.educationalInstitution.name : '-')
              }}
            </div>
          </div>
          <div class="user-detail-item">
            <div class="user-detail-label">User Group</div>
            <div class="user-detail-value">
              {{ values.userGroups ? values.userGroups.groupName : "-" }}
            </div>
          </div>
          <div class="user-detail-item">
            <div class="user-detail-label">User Role</div>
            <div class="user-detail-value">
              {{ values.userRoles ? values.userRoles.roleName : "-" }}
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    user: Object,
  },
  data() {
    return {
      values: [],
    };
  },
  created() {
    if (this.user != null) {
      this.values = this.user;
    }
  },
};
</script>

<style scoped>
.user-detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}

.user-detail-item {
  padding: 12px 14px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  background: #ffffff;
}

.user-detail-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 2px;
  line-height: 1.2;
}

.user-detail-value {
  font-size: 14px;
  color: #0f172a;
  line-height: 1.3;
}
</style>
